import { useStanQuery } from '@/queries';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import { fetchStripeConnectStatus } from '@/lib/api/payments';

/**
 * Query hook to fetch detailed Stripe Connect status
 * Includes instant payout eligibility and other account details
 */
export const useStripeConnectStatus = (enabled = true) => {
    return useStanQuery({
        queryKey: [QUERY_KEYS.STRIPE_CONNECT_STATUS],
        queryFn: fetchStripeConnectStatus,
        enabled,
        staleTime: 1000 * 60 * 5, // 5 minutes
        meta: {
            error: {
                feature: SENTRY_FEATURES.SETTINGS,
                sentryMessage: '[SETTINGS] failed-to-fetch-stripe-connect-status',
            },
        },
    });
};
